import qs from 'qs';

export const getInitialFilters = filters => {
    let newFilters = { ...filters };
    let defaultFilters = { ...filters };
    if (window.location.search) {
        const defaultSearchParams = qs.parse(
            window.location.search.replace('?', '')
        );
        newFilters.modifiers = {
            ...newFilters.modifiers,
            ...defaultSearchParams.filters
        };
    }
    return {
        newFilters,
        defaultFilters
    };
};
